import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import { _CONSTANT_BIRTH, REQUEST_DATA } from 'admin/utils/contants';
import {
  ModalWrapper,
  ModalTitleContainer,
  ModalTitle,
  RequestDate,
  ModalTable,
  UserName,
  ModalTableBody,
  ModalTableRow,
  ModalTableCell,
  CreateOfferButton,
  CloseModalIcon,
  RequestDateAndCloseIcon,
} from 'admin/components/Requsts/styled';

export const RequestViewModal = ({ changedData, openViewModal }) => {
  const navigate = useNavigate();

  return (
    <ModalWrapper>
      <ModalTitleContainer>
        <ModalTitle>
          <UserName>{changedData.Name} </UserName> sent order request
        </ModalTitle>
        <RequestDateAndCloseIcon>
          <RequestDate>{_CONSTANT_BIRTH}</RequestDate>
          <CloseModalIcon src={Images.adminCloseIcon} onClick={openViewModal} />
        </RequestDateAndCloseIcon>
      </ModalTitleContainer>
      <ModalTable>
        <ModalTableBody>
          <ModalTableRow isHeader>
            <ModalTableCell isHeader>Number</ModalTableCell>
            <ModalTableCell isHeader>Question</ModalTableCell>
            <ModalTableCell isHeader>Answer</ModalTableCell>
          </ModalTableRow>
          {REQUEST_DATA.map((element) => (
            <ModalTableRow key={uuid()}>
              <ModalTableCell>{element.id}</ModalTableCell>
              <ModalTableCell>{element.question}</ModalTableCell>
              <ModalTableCell isAnswer>{element.answer}</ModalTableCell>
            </ModalTableRow>
          ))}
        </ModalTableBody>
      </ModalTable>
      <CreateOfferButton
        onClick={() => navigate(`${ROUTES.ADMIN_REQUESTS_OFFER}/${changedData.id}`)}
      >
        Create Offer
      </CreateOfferButton>
    </ModalWrapper>
  );
};
